var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advisor home / meetings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84.7652 20H63.1478H27.4696C22.2087 20.3871 18 24.9355 18 30.3548V55.4194V58.2258V87.6452C18 93.3548 22.5913 98 28.2348 98H84.7652C90.4087 98 95 93.3548 95 87.6452V58.2258V55.4194V30.3548C95 24.6452 90.4087 20 84.7652 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.6824 17H63.0918H27.4578C22.2035 17.3821 18 21.8717 18 27.2211L18 34H95V27.2211C94.9045 21.5852 90.3189 17 84.6824 17Z",
    fill: "#EEF0F8",
    stroke: "#212945",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72.5756 49.0265C72.5756 48.8433 72.4754 48.6747 72.3145 48.5872C72.1536 48.4997 71.9577 48.5072 71.8039 48.6068C69.5346 50.0761 67.2988 51.6435 65.0897 53.2224C64.4233 53.6986 63.5 53.2229 63.5 52.4078C63.5 52.0848 63.6551 51.7836 63.9153 51.5993C64.9018 50.9011 65.9013 50.2196 66.9069 49.5518L66.907 49.5519L66.9174 49.5446C68.3558 48.5356 71.1409 46.5619 72.272 45.7598C72.5107 45.5906 72.7953 45.5 73.0883 45.5C73.868 45.5 74.5 46.132 74.5 46.9117V80.5378C74.5 81.0692 74.0692 81.5 73.5378 81.5C73.0064 81.5 72.5756 81.0692 72.5756 80.5378V49.0265Z",
    fill: "#212945",
    stroke: "#212945",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88 71C84.4399 71 80.9598 72.0557 77.9997 74.0335C75.0397 76.0114 72.7326 78.8226 71.3702 82.1117C70.0078 85.4008 69.6513 89.02 70.3459 92.5116C71.0404 96.0033 72.7547 99.2106 75.2721 101.728C77.7894 104.245 80.9967 105.96 84.4884 106.654C87.98 107.349 91.5992 106.992 94.8883 105.63C98.1774 104.267 100.989 101.96 102.966 99.0003C104.944 96.0402 106 92.5601 106 89C106 86.6362 105.534 84.2956 104.63 82.1117C103.725 79.9278 102.399 77.9435 100.728 76.2721C99.0565 74.6006 97.0722 73.2748 94.8883 72.3702C92.7044 71.4656 90.3638 71 88 71Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8574 57.817L14.1044 38.2099C13.2383 33.7669 17.8574 30 24.4011 30H89.8382C96.3819 30 100.905 33.7669 99.8462 38.2099L95.2873 57.4591",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 98H29.8574C23.23 98 17.8574 92.6274 17.8574 86V57.817L14.1044 38.2099C13.2383 33.7669 17.8574 30 24.4011 30H89.8382C96.3819 30 100.905 33.7669 99.8462 38.2099L95.2873 57.4591V67.5",
    stroke: "#212945",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.737 58L16.0965 39.5751C15.2792 35.3743 19.7462 33 25.922 33H87.8634C94.0392 33 97.8595 35.1552 96.8342 40.0134L92.5624 58",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M72.5756 48.9219C72.5756 48.7398 72.4766 48.572 72.3171 48.4841C72.1577 48.3961 71.963 48.4018 71.8089 48.499C69.5204 49.9423 67.2657 51.4828 65.0383 53.034C64.3883 53.4866 63.5 53.0221 63.5 52.2337C63.5 51.9147 63.6552 51.6179 63.9143 51.4393L63.6386 51.0393L63.9143 51.4393C64.8994 50.7601 65.8976 50.0973 66.9018 49.4477L66.9019 49.4478L66.9123 49.4407C68.3524 48.4568 71.1424 46.5309 72.271 45.7514C72.5084 45.5874 72.7893 45.5 73.0784 45.5H73.9245C74.2424 45.5 74.5 45.7576 74.5 46.0755V62.5378C74.5 63.0692 74.0692 63.5 73.5378 63.5C73.0064 63.5 72.5756 63.0692 72.5756 62.5378V48.9219Z",
    fill: "#212945",
    stroke: "#212945",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M53.5402 62.4553C57.8981 63.5945 60.4982 66.7676 60.5 70.953C60.3924 76.996 55.134 81.5 47.8889 81.5C40.718 81.5 35.6071 77.3986 35.5 71.9272C35.5024 71.3135 36.001 70.8152 36.6111 70.8152C37.2226 70.8152 37.7222 71.3158 37.7222 71.9316H37.722L37.7224 71.9455C37.8442 76.3376 42.4178 79.5769 47.8889 79.5769C53.6116 79.5769 58.0556 76.2028 58.0556 71.2821C58.0556 68.852 57.0373 66.8598 55.1551 65.4916C53.2913 64.1368 50.6198 63.4202 47.3333 63.4202H44.0712C43.5103 63.4202 43.0556 62.9655 43.0556 62.4046C43.0556 61.8436 43.5103 61.3889 44.0712 61.3889H47.3333C49.9768 61.3889 52.2607 60.661 53.895 59.3582C55.5376 58.0487 56.5 56.1745 56.5 53.9601C56.5 49.6943 52.6182 46.6396 47.5556 46.6396C42.8078 46.6396 38.9737 49.591 38.6129 53.8092C38.6117 53.8234 38.6111 53.8376 38.6111 53.8519C38.6111 54.4086 38.1597 54.86 37.603 54.86H37.5C36.893 54.86 36.3963 54.3667 36.389 53.7572C36.7117 48.4548 41.3233 44.5 47.6667 44.5C54.1515 44.5 58.8333 48.4758 58.8333 53.6353C58.8333 57.2204 56.8465 60.1751 53.4826 61.5066C53.2816 61.5862 53.1545 61.786 53.1676 62.0018C53.1807 62.2176 53.331 62.4006 53.5402 62.4553Z",
    fill: "#212945",
    stroke: "#212945",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M88 71C84.4399 71 80.9598 72.0557 77.9997 74.0335C75.0397 76.0114 72.7326 78.8226 71.3702 82.1117C70.0078 85.4008 69.6513 89.02 70.3459 92.5116C71.0404 96.0033 72.7547 99.2106 75.2721 101.728C77.7894 104.245 80.9967 105.96 84.4884 106.654C87.98 107.349 91.5992 106.992 94.8883 105.63C98.1774 104.267 100.989 101.96 102.966 99.0003C104.944 96.0402 106 92.5601 106 89C106 86.6362 105.534 84.2956 104.63 82.1117C103.725 79.9278 102.399 77.9435 100.728 76.2721C99.0565 74.6006 97.0722 73.2748 94.8883 72.3702C92.7044 71.4656 90.3638 71 88 71Z",
    fill: "white",
    stroke: "#212945",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M103 89.9346C102.898 89.9365 102.795 89.9374 102.693 89.9374C93.6737 89.9374 86.2888 82.9058 85.67 74C78.4911 75.1324 73 81.3759 73 88.9084C73 97.2432 79.7234 104 88.0171 104C95.9676 104 102.475 97.7909 103 89.9346Z",
    fill: "#EEF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M96.8277 83.218L96.1159 83.9204L96.8277 83.218C95.9366 82.3149 94.4789 82.3149 93.5878 83.218L85.9654 90.9433L83.4122 88.3557C82.5211 87.4525 81.0634 87.4525 80.1723 88.3557C79.2979 89.2419 79.2979 90.6663 80.1723 91.5525L84.2369 95.672C85.1877 96.6357 86.743 96.6357 87.6938 95.672L96.8277 86.4148C97.7021 85.5286 97.7021 84.1043 96.8277 83.218Z",
    fill: "white",
    stroke: "#212945",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 192",
    cx: 36.5,
    cy: 23.5,
    r: 2.5,
    fill: "white",
    stroke: "#212945",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 193",
    cx: 75.5,
    cy: 23.5,
    r: 2.5,
    fill: "white",
    stroke: "#212945",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCalendar);
export default __webpack_public_path__ + "static/media/paperCalendar.28f9e4da62265bf6b1454c921a332178.svg";
export { ForwardRef as ReactComponent };